/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import API from 'API'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/projects'
        },
        {
          path: '/projects/:id/edit/type-1',
          name: 'canvas',
          component: () => import('./views/CanvasConstructor.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/projects/:id/edit/type-2',
          name: 'canvas2',
          component: () => import('./views/Canvas2Constructor.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/projects',
          name: 'projects',
          component: () => import('./views/Projects.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/project/:id/type',
          name: 'project-type',
          component: () => import('./views/ProjectType.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/analytics',
          name: 'analytics',
          component: () => import('./views/AnalyticsPage.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/appeal',
          name: 'appeal',
          component: () => import('./views/AppealPage.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/integrations',
          name: 'integrations',
          component: () => import('./views/Integrations.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/integrations/add',
          name: 'integrations_add',
          component: () => import('./views/IntegrationsAdd.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/integrations/amo',
          name: 'amo-integrations',
          component: () => import('./views/AmoIntegration.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/integrations/bitrix',
          name: 'bitrix-integrations',
          component: () => import('./views/BitrixIntegration.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/integrations/amo/:id',
          name: 'amo-page',
          component: () => import('./views/AmoPage.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/integrations/bitrix/:id',
          name: 'bitrix-page',
          component: () => import('./views/BitrixPage.vue'),
          meta: {
            rule: 'editor'
          }
        },

        //CATALOG 
        {
          path: '/department/',
          name: 'department',
          component: () => import('./views/catalog/Department.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/locations/',
          name: 'locations',
          component: () => import('./views/catalog/Locations.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/specialist/',
          name: 'specialist',
          component: () => import('./views/catalog/Specialist.vue'),
          meta: {
            rule: 'editor'
          }
        },

        {
          path: '/department/add',
          name: 'department_add',
          component: () => import('./views/catalog/DepartmentAdd.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/locations/add',
          name: 'locations_add',
          component: () => import('./views/catalog/LocationsAdd.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/specialist/add',
          name: 'specialist_add',
          component: () => import('./views/catalog/SpecialistAdd.vue'),
          meta: {
            rule: 'editor'
          }
        },

        {
          path: '/department/:id',
          name: 'department_page',
          component: () => import('./views/catalog/DepartmentPage.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/locations/:id',
          name: 'locations_page',
          component: () => import('./views/catalog/LocationsPage.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/specialist/:id',
          name: 'specialist_page',
          component: () => import('./views/catalog/SpecialistPage.vue'),
          meta: {
            rule: 'editor'
          }
        },
        

      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () => import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

router.beforeEach((to, from, next) => {
  if (
    to.path === "/pages/login" ||
    to.path === "/pages/forgot-password" ||
    to.path === "/pages/error-404" ||
    to.path === "/pages/error-500" ||
    to.path === "/pages/register" ||
    to.path === "/callback" ||
    to.path === "/pages/comingsoon"
  ) {
    return next();
  }

  API.user.checkAuth(localStorage.getItem('access_token'))
    .then(res => {
      if (res.status === 200) {
        return next();
      } else {
        throw 'Login error';
      }
    })
    .catch(() => {
      console.log('Login error. It cause create NavigationDuplicated')
      router.push({path: '/pages/login', query: {to: to.path}})
    })

});

export default router